import { cn } from "@/lib/utils";
import type { Severity } from "@/lib/types";

interface Props {
  severity: Severity;
  className?: string;
}

export function SeverityBadge({ severity, className }: Props) {
  const map = {
    high: "bg-destructive text-destructive-foreground",
    medium: "bg-amber-500 text-white",
    low: "bg-slate-400 text-white",
  } as const;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-micro font-semibold uppercase tracking-wider",
        map[severity],
        className
      )}
    >
      {severity}
    </span>
  );
}
